'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./styles.scss');

var _classnames = require('../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Page(_ref) {
  var children = _ref.children,
      translate = _ref.translate;

  var classes = (0, _classnames2.default)('page', translate && 'page--translate');

  return _react2.default.createElement(
    'div',
    { className: classes },
    children
  );
}

Page.propTypes = {
  children: _propTypes2.default.node,
  translate: _propTypes2.default.bool
};

exports.default = Page;